import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { updateBodyClasses } from './hooks/update-body-classes.js'
import { Events } from '../events.js'

export const registerSwupHooks = (swup, ctx) => {
	const { componentsManager, eventBus, browser, scrollSmootherManager } = ctx

	swup.hooks.on(
		'content:replace',
		() => {
			const container = document.querySelector('#swup')
			componentsManager?.removeComponents(container)
			browser?.enableScroll()
		},
		{ before: true },
	)

	swup.hooks.on('content:replace', updateBodyClasses)

	swup.hooks.on(
		'content:replace',
		() => {
			const container = document.querySelector('#swup')

			scrollSmootherManager?.recreate?.()

			componentsManager?.loadComponents(container, () => {
				const triggers = ScrollTrigger.getAll()

				if (triggers && triggers.length) {
					ScrollTrigger.sort()
					ScrollTrigger.refresh()
				}
			})

			eventBus?.emit(Events.SWUP_CONTENT_REPLACE, {})
		},
		{ after: true },
	)

	swup.hooks.on('page:view', (visit) => {
		eventBus?.emit(Events.SWUP_PAGE_VIEW, visit)
		queueMicrotask(() => eventBus?.emit(Events.PAGE_READY, visit))
	})

	swup.hooks.on('visit:start', (visit) => {
		ctx.currentTransition = visit
	})
}
